import { render, staticRenderFns } from "./ClientReservation.vue?vue&type=template&id=76cca27a"
import script from "./ClientReservation.vue?vue&type=script&lang=js"
export * from "./ClientReservation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports